export const formatDiscountCountdown = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000))
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (value: number) => String(value).padStart(2, '0')

  // The days segment appears only when at least one whole day remains —
  // under 24h the pattern stays `Xh : XXm : XXs`
  if (days > 0) {
    return `${days}d : ${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`
  }

  return `${hours}h : ${pad(minutes)}m : ${pad(seconds)}s`
}
